
























































import Vue from "vue";
import { mapState, mapGetters } from "vuex";

export default Vue.extend({
  data() {
    return {
      dialog: false,
      dialogModel: {
        value: "",
        method: "",
        path: "",
        suit: {}
      }
    };
  },
  computed: {
    ...mapState(["currentSuit"]),
    ...mapGetters({
      folders: "testSuiteTree"
    })
  },
  methods: {
    suitActivated(items: any) {
      this.$store.commit("setCurrentSuit", items.length != 0 ? items[0] : null);
    },
    newSuit() {
      this.openDialog({
        title: "New suit",
        method: "createSuit",
        path: "/"
      });
    },
    newFolder() {
      this.openDialog({
        title: "New folder",
        method: "createFolder",
        path: "/"
      });
    },
    renameSuit(suit: any) {
      this.openDialog({
        title: "Rename test suit",
        method: "doRenameSuit",
        value: suit.name,
        suit: suit
      });
    },
    duplicateSuit(suit: any) {
      this.openDialog({
        title: "Duplicate test suit",
        method: "doDuplicateSuit",
        path: "/",
        suit: suit
      });
    },
    openDialog(model: any) {
      this.dialogModel = model;
      this.dialog = true;
      this.$nextTick(() => (this.$refs.newField as any).focus());
    },
    dialogSave() {
      const name = this.dialogModel.value;
      switch (this.dialogModel.method) {
        case "createFolder":
          this.createFolder(name);
          break;
        case "createSuit":
          this.createSuit(name);
          break;
        case "doRenameSuit":
          this.doRenameSuit(this.dialogModel.suit, name);
          break;
        case "doDuplicateSuit":
          this.doDuplicateSuit(this.dialogModel.suit, name);
          break;
      }
      this.dialog = false;
    },
    createSuit(name: any) {
      this.$store.dispatch("createTestSuit", name);
    },
    doRenameSuit(suit: any, name: any) {
      this.$store.dispatch("updateTestSuit", { ...suit, name });
    },
    doDuplicateSuit(suit: any, newName: any) {
      this.$store.dispatch("duplicateTestSuit", { suit, newName });
    },
    createFolder(name: any) {
      // this.folders.push({ name: name, type: "folder" });
    },
    deleteSuit(suit: any) {
      this.$store.dispatch("deleteTestSuit", suit);
    }
  }
});
